import { DetectedRegionsState } from 'stores/types';

export const initialState: DetectedRegionsState = {
  detectedRegions: {},
};
